/**
 * Shared excerpt clamp for the "related posts" cards that sit at the bottom of
 * the free-tools, use-cases and industries pages.
 *
 * It replaces the inline `post.excerpt.replace(...).slice(0, 120) + '...'` that
 * those cards used to repeat, which had two problems:
 *   1. the ellipsis was appended unconditionally, so an excerpt shorter than the
 *      limit advertised missing text that did not exist (294 of 731 live posts).
 *   2. the cut landed mid-word.
 *
 * Truncation here is presentational only. The full excerpt still reaches the
 * page wherever the card can show it, and the post's own page carries the full
 * copy, so nothing indexable is lost.
 */
export const clampExcerpt = (html?: string, max = 120): string => {
  const text = (html || '').replace(/(<([^>]+)>)/gi, '').trim();

  if (text.length <= max) {
    return text;
  }

  const cut = text.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');

  // Only fall back to a word boundary when one exists late enough in the string
  // that we are not throwing away most of the excerpt (very long single tokens,
  // e.g. a bare URL, keep the hard cut).
  return `${(lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd()}...`;
};
